var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWeather(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    focusable: "false",
    "data-prefix": "fas",
    className: "svg-inline--fa",
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 25.762 27.815",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_49",
    "data-name": "Rectangle 49",
    width: 25.762,
    height: 27.815,
    fill: "#157eb8"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_32",
    "data-name": "Groupe 32",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_163",
    "data-name": "Trac\\xE9 163",
    d: "M179.2,9.016h.036a.6.6,0,0,0,.6-.567l.053-.906a.6.6,0,0,0-1.2-.07l-.053.906a.6.6,0,0,0,.566.636",
    transform: "translate(-162.16 -6.269)",
    fill: "#157eb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_164",
    "data-name": "Trac\\xE9 164",
    d: "M143.32,2.706a.6.6,0,1,0,1.139-.391L143.8.407A.6.6,0,1,0,142.665.8Z",
    transform: "translate(-129.478 0)",
    fill: "#157eb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_165",
    "data-name": "Trac\\xE9 165",
    d: "M207.7,7.575A.6.6,0,0,0,208.5,7.3l.886-1.812a.6.6,0,1,0-1.082-.529l-.886,1.812a.6.6,0,0,0,.277.806",
    transform: "translate(-188.234 -4.193)",
    fill: "#157eb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_166",
    "data-name": "Trac\\xE9 166",
    d: "M20.444,44.054v-.013a3.952,3.952,0,0,0-.1-.893.6.6,0,0,0,.955.04,6.018,6.018,0,1,0-10.531-5.006A3.09,3.09,0,0,0,6.592,39.83a2.336,2.336,0,0,0-.248-.013A2.312,2.312,0,0,0,4.29,41.069a3.09,3.09,0,1,0-1.2,5.937H4.331A2.533,2.533,0,0,0,6.51,50.832h5.645v2.39a.777.777,0,0,0,.776.776h1.06L13.876,57.1a.918.918,0,0,0,.685.926.936.936,0,0,0,.24.031.917.917,0,0,0,.814-.5l.887-1.7a.6.6,0,1,0-1.068-.558l-.308.589.093-2.483a.6.6,0,0,0-.6-.625H13.361V50.832h2.428l-.211.776a.776.776,0,0,0,.749.98h.555l-.747,1.535a.6.6,0,1,0,1.083.527l1.042-2.141a.776.776,0,0,0-.693-1.125h-.68l.15-.551h2.325a3.475,3.475,0,0,0,1.083-6.777m-6.972-8.313a4.814,4.814,0,0,1,6.9,6.675.6.6,0,0,0-.138.352,3.961,3.961,0,0,0-3.745-2.684,3.93,3.93,0,0,0-2.911,1.281,2.444,2.444,0,0,0-1.027-.427,3.074,3.074,0,0,0-.683-1.893,4.781,4.781,0,0,1,1.605-3.305M1.2,43.916A1.888,1.888,0,0,1,3.09,42.031a1.865,1.865,0,0,1,1.177.413.6.6,0,0,0,.976-.417,1.112,1.112,0,0,1,1.1-1.005,1.1,1.1,0,0,1,.431.087.6.6,0,0,0,.829-.452,1.885,1.885,0,0,1,3.742.325,1.906,1.906,0,0,1-.046.414.6.6,0,0,0,.672.728,1.275,1.275,0,0,1,.176-.013,1.25,1.25,0,0,1,.759.256l-.012.024a2.538,2.538,0,0,0-2.216.8,3.146,3.146,0,0,0-4.6,2.606H3.09A1.888,1.888,0,0,1,1.2,43.916m18.157,5.711H6.51A1.329,1.329,0,0,1,6.238,47l.026,0a1.331,1.331,0,0,1,.246-.024h.005c.041,0,.083,0,.123.006a1.309,1.309,0,0,1,.715.3.6.6,0,0,0,.765-.931,2.531,2.531,0,0,0-.834-.452A1.942,1.942,0,0,1,9.22,44.041a1.919,1.919,0,0,1,1.233.442.6.6,0,0,0,.918-.189,1.328,1.328,0,0,1,1.674-.626.6.6,0,0,0,.8-.392,2.751,2.751,0,0,1,5.393.765,2.792,2.792,0,0,1-.028.393.6.6,0,0,0,.5.68,2.27,2.27,0,0,1-.353,4.513",
    transform: "translate(0 -30.247)",
    fill: "#157eb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_167",
    "data-name": "Trac\\xE9 167",
    d: "M248.654,60.853a.6.6,0,0,0-.765-.374l-1.908.655a.6.6,0,1,0,.391,1.14l1.908-.655a.6.6,0,0,0,.374-.765",
    transform: "translate(-222.924 -54.871)",
    fill: "#157eb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_168",
    "data-name": "Trac\\xE9 168",
    d: "M245.671,119.373l-1.847-.811a.6.6,0,0,0-.484,1.1l1.847.811a.6.6,0,0,0,.484-1.1",
    transform: "translate(-220.569 -107.581)",
    fill: "#157eb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_169",
    "data-name": "Trac\\xE9 169",
    d: "M87.142,50.441l1.812.886a.6.6,0,1,0,.529-1.082l-1.812-.886a.6.6,0,0,0-.529,1.082",
    transform: "translate(-78.799 -44.751)",
    fill: "#157eb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_170",
    "data-name": "Trac\\xE9 170",
    d: "M231.2,37.175a.6.6,0,0,0,.4-.152l.678-.6a.6.6,0,1,0-.8-.9l-.678.6a.6.6,0,0,0,.4,1.052",
    transform: "translate(-209.327 -32.105)",
    fill: "#157eb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_171",
    "data-name": "Trac\\xE9 171",
    d: "M250.1,97.655l.906.053h.036a.6.6,0,0,0,.035-1.2l-.906-.053a.6.6,0,1,0-.07,1.2",
    transform: "translate(-226.518 -87.555)",
    fill: "#157eb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_172",
    "data-name": "Trac\\xE9 172",
    d: "M118.308,30a.6.6,0,0,0,.9-.8l-.6-.679a.6.6,0,0,0-.9.8Z",
    transform: "translate(-106.711 -25.706)",
    fill: "#157eb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_173",
    "data-name": "Trac\\xE9 173",
    d: "M52.057,235.354a.6.6,0,0,0,.8-.284l.358-.75a.6.6,0,0,0-1.087-.519l-.359.75a.6.6,0,0,0,.284.8",
    transform: "translate(-46.945 -211.927)",
    fill: "#157eb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_174",
    "data-name": "Trac\\xE9 174",
    d: "M42.716,254.9a.6.6,0,0,0-.8.284l-.358.75a.6.6,0,1,0,1.087.519l.359-.75a.6.6,0,0,0-.284-.8",
    transform: "translate(-37.668 -231.34)",
    fill: "#157eb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_175",
    "data-name": "Trac\\xE9 175",
    d: "M32.653,277.227a.6.6,0,0,0-.8.284l-.358.75a.6.6,0,1,0,1.087.519l.358-.75a.6.6,0,0,0-.284-.8",
    transform: "translate(-28.534 -251.605)",
    fill: "#157eb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_176",
    "data-name": "Trac\\xE9 176",
    d: "M75.743,235.354a.6.6,0,0,0,.8-.284l.358-.75a.6.6,0,0,0-1.087-.519l-.359.75a.6.6,0,0,0,.284.8",
    transform: "translate(-68.446 -211.927)",
    fill: "#157eb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_177",
    "data-name": "Trac\\xE9 177",
    d: "M66.4,254.9a.6.6,0,0,0-.8.284l-.359.75a.6.6,0,1,0,1.087.519l.358-.75a.6.6,0,0,0-.284-.8",
    transform: "translate(-59.171 -231.339)",
    fill: "#157eb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_178",
    "data-name": "Trac\\xE9 178",
    d: "M56.34,277.227a.6.6,0,0,0-.8.284l-.358.75a.6.6,0,1,0,1.087.519l.358-.75a.6.6,0,0,0-.284-.8",
    transform: "translate(-50.036 -251.605)",
    fill: "#157eb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_179",
    "data-name": "Trac\\xE9 179",
    d: "M28.468,235.355a.6.6,0,0,0,.8-.284l.358-.75a.6.6,0,0,0-1.087-.519l-.358.75a.6.6,0,0,0,.284.8",
    transform: "translate(-25.531 -211.927)",
    fill: "#157eb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_180",
    "data-name": "Trac\\xE9 180",
    d: "M19.127,254.9a.6.6,0,0,0-.8.284l-.358.75a.6.6,0,1,0,1.087.519l.359-.75a.6.6,0,0,0-.284-.8",
    transform: "translate(-16.255 -231.34)",
    fill: "#157eb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_181",
    "data-name": "Trac\\xE9 181",
    d: "M9.064,277.228a.6.6,0,0,0-.8.284l-.358.75a.6.6,0,1,0,1.087.519l.359-.75a.6.6,0,0,0-.284-.8",
    transform: "translate(-7.12 -251.606)",
    fill: "#157eb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_182",
    "data-name": "Trac\\xE9 182",
    d: "M102.26,233.518a.6.6,0,0,0-.8.284l-.358.75a.6.6,0,1,0,1.087.519l.359-.75a.6.6,0,0,0-.284-.8",
    transform: "translate(-91.721 -211.927)",
    fill: "#157eb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_183",
    "data-name": "Trac\\xE9 183",
    d: "M92.042,254.9a.6.6,0,0,0-.8.284l-.358.75a.6.6,0,1,0,1.087.519l.358-.75a.6.6,0,0,0-.284-.8",
    transform: "translate(-82.445 -231.339)",
    fill: "#157eb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_184",
    "data-name": "Trac\\xE9 184",
    d: "M81.978,277.227a.6.6,0,0,0-.8.284l-.358.75a.6.6,0,1,0,1.087.519l.358-.75a.6.6,0,0,0-.284-.8",
    transform: "translate(-73.31 -251.605)",
    fill: "#157eb8"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeather);
export default __webpack_public_path__ + "static/media/weather.dd689620451a8827790e15c67d23cb70.svg";
export { ForwardRef as ReactComponent };